import moment from 'moment'

export default function(tarih, tarihFormati) {
    try {
        return moment(tarih).format(tarihFormati)
    } catch (error) {
        return tarih
    }
}